import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, HtmlRaw, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import { VideoScorm } from '../../../components';
import {
  SCORM_DETAILS_GET,
  SCORM_DETAILS_RESET,
} from '../../../../app/redux/actions/scorm';

export const ModalPreviewScormId = 'ModalPreviewScorm';

const ModalPreviewScorm = ({
  mediaIsPhone,
  id,
  payload,
  getScormDetails,
  item,
  modalClose,
  scormReset,
}) => {
  const scrollableAreaRef = useRef(null);

  useEffect(() => {
    if (id === ModalPreviewScormId) {
      if (payload?.scormId) getScormDetails(payload?.scormId);
      else modalClose();
    }
    return () => scormReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payload]);

  return (
    <Modal
      title="Anteprima attività:"
      modalId={ModalPreviewScormId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <ScrollableArea
        ref={scrollableAreaRef}
        style={{ minWidth: 'min(75vw, 1032px)', minHeight: '60vh' }}
      >
        <Text type="h2" mb={8}>
          {item.title}
        </Text>
        <Text type="b3" mb={16}>
          {item.code}
        </Text>
        {item?.description && (
          <>
            <Text type="h3" mb={8}>
              Descrizione attività
            </Text>
            <Text type="b3" mb={24}>
              <HtmlRaw html={item.description} />
            </Text>
          </>
        )}
        {item?.scorm_url && (
          <VideoScorm
            selectedActivity={{ data: { scorm_url: item.scorm_url } }}
          />
        )}
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="Chiudi"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
      </Footer>
    </Modal>
  );
};

ModalPreviewScorm.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  id: PropTypes.string,
  payload: PropTypes.object,
  item: PropTypes.object,
  // dispatch
  modalClose: PropTypes.func.isRequired,
  getScormDetails: PropTypes.func.isRequired,
  scormReset: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { id, payload } = state.app.modal;
      const { details: item } = state.scorm;
      return { id, payload, item };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getScormDetails: (id) =>
        dispatch({ type: SCORM_DETAILS_GET._REQUEST, id }),
      scormReset: () => dispatch({ type: SCORM_DETAILS_RESET }),
    })
  ),
  withMediaQueries
)(ModalPreviewScorm);
